import { render } from "./ListForInspector.vue?vue&type=template&id=fb95573c"
import script from "./ListForInspector.vue?vue&type=script&lang=js"
export * from "./ListForInspector.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__